export default {
    namespaced: true,
    state: {
        downImgList: {},
        downList: {}
    },
    mutations: {},
    actions: {},
}
